import React, {
    Component,
} from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';

class InputField extends Component {
    state = {
        focused: false,
    };

    onFocus = () => this.setState({ focused: true });

    onBlur = () => this.setState({ focused: false });

    render() {
        const {
            value = '', onChange, label, type, handleKeyPress,
            autoFocus, errorMessage, hasErrored, readOnly, disabled,
        } = this.props;

        return (
            <div className={c('input input-arteia input--flex art-field', {
                'input--filled': this.state.focused || value.length,
                'field-error': hasErrored,
            })}>
                <input className="input__field input__field--arteia art-input"
                       disabled={disabled}
                       type={type}
                       value={value}
                       autoFocus={autoFocus}
                       onChange={onChange}
                       readOnly={readOnly}
                       onFocus={this.onFocus}
                       onBlur={this.onBlur} onKeyPress={handleKeyPress}
                />
                <label className="input__label input__label--arteia art-label">
                    <span className="input__label-content">{label}</span>
                </label>
                {hasErrored
                && <div className="art-error-msg">
                    {errorMessage}
                </div>}
            </div>
        );
    }
}

InputField.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    autoFocus: PropTypes.bool,
    handleKeyPress: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    type: PropTypes.string,
    hasErrored: PropTypes.bool,
    readOnly: PropTypes.bool,
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    disabled: PropTypes.bool,
};
InputField.defaultProps = {
    type: 'text',
    hasErrored: false,
    disabled: false,
};

export default InputField;



// WEBPACK FOOTER //
// ./src/arteia-js/components/InputField/index.js